import { getListItemsInRange } from "./getListItemsInRange.js";
import { getParentList } from "./getParentList.js";
/**
 * Get all lists in the given Range.
 */
export function getListsInRange(editor, at) {
  var listItemsInRange = getListItemsInRange(editor, at);
  var lists = listItemsInRange.map(_ref => {
    var [, listItemPath] = _ref;
    return getParentList(editor, listItemPath);
  }).filter(list => list !== null);
  // TypeScript complains about `null`s even though we filter for them, hence the typecast.
  return lists;
}